/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class transtypereference extends IceEntity {
  trans_type_reference_key: string = "";
  trans_type_code: IceTypes.TRANSTYPE.itNone;
  connection_parameters_key: string = "";
  server_connection_parameters_key: string = "";
  test_required: boolean = false;
  record_version: number = 0;
  offline_record_status: number = 0;

  gettablename(): string {
  return "TRANS_TYPE_REFERENCE";
  }
}
